module.exports = __webpack_public_path__ + "static/connections-0e9bdddcbd884835c936839cc4bf0f56.gif";